
import { Component, Vue, Watch, Prop, Ref, Emit } from "vue-property-decorator";
import OCRApi from "@/api/ocr-api";

import ImageViewer from "./ImageViewer.vue";
import { ImagePreview } from "vant";

type MainType = { url: string, id: NString, ocr?: OCRApi.IOCRResult, scanning: boolean };


@Component({ name: "item-editor-photo", components: { ImageViewer } })
export default class ItemEditorCustom extends Vue {

    scale = 1;
    translateX = 0;
    translateY = 0;
    isScaled = false;
    currentSwipeIndex = 0;

    @Prop() dataSource!: MainType[]

    @Prop() orderId!: number

    swipeChange(idx: number) {
        this.currentSwipeIndex = idx;
        const fileInfo = this.dataSource[this.currentSwipeIndex];
        if (fileInfo.scanning) return;
        if (fileInfo.ocr) this.ocrChange(fileInfo)
        else this.doScan(fileInfo.id)
    }

    async doDel() {
        var m = this.dataSource[this.currentSwipeIndex];
        if (!m) return;
        this.$emit("onDelete", m)
    }

    @Emit("onPhoto")
    onPhoto() { }

    @Watch("onDelete")
    onDelete(m: MainType) { }

    doScan(fileId: NString) {
        if (!fileId) return;

        var fileInfo = this.dataSource.find(e => e.id == fileId)!;
        if (!fileInfo || fileInfo.scanning || fileInfo.ocr) return;
        this.$set(fileInfo, "scanning", true);
        OCRApi.scan({ FileID: fileId, OrderId: this.orderId })
            .then(e => {
                fileInfo.ocr = e;
                this.ocrChange(fileInfo);
            }).finally(() => fileInfo!.scanning = false)
    }

    @Emit("ocrChange")
    ocrChange(fileInfo: MainType) { }

    @Watch("dataSource")
    dataSourceOnChange(v: Array<unknown>) {
        if (v.length) this.swipeChange(0);
    }

    showPreview(url: string) {
        var idx = this.dataSource.findIndex(e => e.url == url);
        ImagePreview(this.dataSource.map(e => e.url), Math.min(idx, 0))
    }
}
